<div class="preview-container" id="preview-container" [style]="backgroundImageStyles">
  <!-- Si forme libre choisie -->
  @if (configuration.shape !== undefined && configuration.shape?.id === 0) {
    <p class="preview-free-shape">
      {{ 'fence.preview.free-shape' | translate }}
    </p>
  }
</div>

